import * as CryptoJS from 'crypto-js';
import { environment } from '../../environments/environment';

export class SecurityUtils {
  private static ENCRYPTION_SECRET = environment.ENCRYPTION_SECRET || '';
  private static HMAC_SECRET = environment.HMAC_SECRET || '';

  /**
   * Encrypts a sensitive string using AES-256-CBC
   */
  public static encryptSensitiveData(plainText: any): string {
    if (!plainText) return plainText;
    let plainTextStr = '';
    if (typeof plainText === 'object') {
      plainTextStr = JSON.stringify(plainText);
    } else {
      plainTextStr = String(plainText);
    }
    if (!this.ENCRYPTION_SECRET) {
      console.warn("Missing ENCRYPTION_SECRET on frontend");
      return plainText;
    }

    const keyString = this.ENCRYPTION_SECRET.substring(0, 32);
    const key = CryptoJS.enc.Utf8.parse(keyString);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(plainTextStr, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const ivHex = iv.toString(CryptoJS.enc.Hex);
    const encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);

    return `${ivHex}:${encryptedHex}`;
  }

  /**
   * Generates an HMAC SHA-256 signature for API headers
   */
  public static generateRequestSignature(requestBody: unknown): { signature: string; timestamp: string } {
    if (!this.HMAC_SECRET) {
      console.warn("Missing HMAC_SECRET on frontend");
      return { signature: "", timestamp: "0" };
    }

    const timestamp = Math.floor(Date.now() / 1000).toString();
    const payloadString = JSON.stringify(requestBody);
    const dataToSign = `${timestamp}.${payloadString}`;

    const signature = CryptoJS.HmacSHA256(dataToSign, this.HMAC_SECRET).toString(CryptoJS.enc.Hex);

    return { signature, timestamp };
  }
}
